<template>
    <div class="w-full pb-3">
        <div v-if="bills && total > 0" v-for="(el, key) in bills" :key="el.id"
            class="w-fill flex flex-column surface-0 relative overflow-hidden
                shadow-3 xl:shadow-6
                border-round-xl xl:border-round-2xl
                p-3 xl:p-4
                mb-3 xl:mb-4">
            <div class="w-full flex flex-row
                mb-3 xl:mb-4" >
                <div class="flex flex flex-column flex-1">
                    <span v-if="el.date_created" class="flex text-600
                        mb-2 xl:mb-3
                        text-xs xl:text-sm">
                        {{ content[lang_].bill_title }} {{ formatDate(el.date_created) }}
                    </span>
                    <span v-if="el.amount && el.currency_code" class="flex font-medium text-800 white-space-nowrap
                        mb-2 xl:mb-3
                        text-xl xl:text-3xl">
                        {{ get_format_amount(el.amount, el.currency_code, 0) }}
                    </span>
                    <span v-else class="flex font-medium text-800 white-space-nowrap mb-2 xl:mb-3 text-xl xl:text-3xl">
                        {{ content[lang_].noAmount }}
                    </span>
                    <div v-if="el.recipient && el.recipient.bank_code" class="flex relative py-2 xl:py-3 align-items-center">
                        <Avatar :image="getBankImage(el.recipient.bank_code)" class="absolute top-0 left-0 h-full" shape="circle" size="small"/>
                        <span class="text-600 absolute white-space-nowrap left-0 top-0 bottom-0 vertical-align-middle
                            ml-4 xl:ml-5
                            pl-1 py-1 xl:py-2 xl:pl-2
                            text-xs xl:text-sm">{{ getBankTitle(el.recipient.bank_code) }}</span>
                    </div>
                </div>
                <div v-if="el.recipient" class="flex flex-column flex-1">
                    <div v-if="el.recipient.fullname" class="flex flex-initial pr-2">
                        <span class="flex text-600 align-items-center
                        mb-2 xl:mb-3
                        text-xs xl:text-sm">
                            <i class="pi pi-user mr-2"></i>
                            <span class="hidden mr-1 xl:inline lg:inline md:inline">{{ content[lang_].recipient_fullname }}:</span> 
                            <span>{{ el.recipient.fullname }}</span>
                        </span>
                    </div>
                    <div v-if="el.recipient.account_number" class="flex flex-initial pr-2">
                        <span class="flex text-600 align-items-center
                        mb-2 xl:mb-3
                        text-xs xl:text-sm">
                            <i class="pi pi-id-card mr-2"></i>
                            <span class="hidden mr-1 xl:inline lg:inline md:inline">{{ content[lang_].account_number }}:</span> 
                            <span>{{ el.recipient.account_number }}</span>
                        </span>
                    </div>
                    <div v-if="el.recipient.card_number" class="flex flex-initial pr-2">
                        <span class="flex text-600 align-items-center
                        mb-2 xl:mb-3
                        text-xs xl:text-sm">
                            <i class="pi pi-id-card mr-2"></i>
                            <span class="hidden mr-1 xl:inline lg:inline md:inline">{{ content[lang_].card_number }}:</span> 
                            <span>{{ el.recipient.card_number }}</span>
                        </span>
                    </div>
                    <div v-if="el.recipient.phone_number" class="flex flex-initial pr-2">
                        <span class="flex text-600 align-items-center
                        mb-2 xl:mb-3
                        text-xs xl:text-sm">
                            <i class="pi pi-phone mr-2"></i>
                            <span class="hidden mr-1 xl:inline lg:inline md:inline">{{ content[lang_].phone_number }}:</span> 
                            <span>{{ el.recipient.phone_number }}</span>
                        </span>
                    </div>
                    <div v-if="el.recipient.wallet_address" class="flex flex-initial pr-2">
                        <span class="flex text-600 align-items-center
                        mb-2 xl:mb-3
                        text-xs xl:text-sm">
                            <i class="pi pi-wallet mr-2"></i>
                            <span class="hidden mr-1 xl:inline lg:inline md:inline">{{ content[lang_].wallet_address }}:</span> 
                            <span>{{ el.recipient.wallet_address }}</span>
                        </span>
                    </div>
                    <div v-if="el.recipient.wallet_network" class="flex flex-initial pr-2">
                        <span class="flex text-600 align-items-center
                        mb-2 xl:mb-3
                        text-xs xl:text-sm">
                            <i class="pi pi-code mr-2"></i>
                            <span class="hidden mr-1 xl:inline lg:inline md:inline">{{ content[lang_].wallet_network }}:</span> 
                            <span>{{ el.recipient.wallet_network }}</span>
                        </span>
                    </div>
                    <div v-if="el.recipient.telegram" class="flex flex-initial pr-2">
                        <span class="flex text-600 align-items-center
                        mb-2 xl:mb-3
                        text-xs xl:text-sm">
                            <i class="pi pi-telegram mr-2"></i>
                            <span class="hidden mr-1 xl:inline lg:inline md:inline">{{ content[lang_].telegram }}:</span> 
                            <span>{{ el.recipient.telegram }}</span>
                        </span>
                    </div>
                    <span v-if="el.description" class="flex text-600 align-items-center
                        mb-2 xl:mb-3
                        text-xs xl:text-sm">
                        <i class="pi pi-info-circle mr-2"></i>
                        <span class="hidden mr-1 xl:inline lg:inline md:inline">{{ content[lang_].description }}:</span> 
                        <span>{{ el.description }}</span>
                    </span>
                </div>
            </div>
            <div class="flex flex-row gap-2">
                <Button :label="content[lang_].btn_detail" @click="detail_page(el.id)" class="flex border-2 border-round-lg mr-2" size="small" outlined severity="info"/>

                <Button v-if="!isTgApp" :label="content[lang_].btn_to_pay" @click="payPage(el.hash)" outlined class="flex flex-initial border-2 border-round-lg" icon="pi pi-external-link" iconPos="right" severity="secondary" size="small" />
                <Button v-if="isTgApp" :label="content[lang_].btn_to_pay" @click="payPageTg(el.hash)" outlined class="flex flex-initial border-2 border-round-lg" severity="secondary" size="small" />

                <Button v-if="!isTgApp" @click="copy(el.hash)" outlined class="flex flex-initial border-2 border-round-lg" icon="pi pi-copy" iconPos="right" severity="secondary" size="small" />

                <Button v-if="isTgApp" @click="copyTg(el.hash)" outlined class="flex flex-initial border-2 border-round-lg" icon="pi pi-copy" iconPos="right" severity="secondary" size="small" />
                <Button v-if="isTgApp" @click="shareTg(el.hash)" outlined class="flex flex-initial border-2 border-round-lg" icon="pi pi-upload" iconPos="right" severity="secondary" size="small" />
            </div>
        </div>
        <div v-if="(!bills && total==null) || loading" class="w-full">
            <Skeleton height="8rem" class="mb-3"/>
            <Skeleton height="8rem" class="mb-3"/>
            <Skeleton height="8rem" class="mb-3"/>
            <Skeleton height="8rem" class="mb-3"/>
            <Skeleton height="8rem" class="mb-3"/> 
        </div>
    </div>
</template>
  
<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import { BankList } from '@/assets/js/classes/PaymentSystem.js'

export default {
    props: ['bills', 'total'],
    data() {
        return {
            header: {
                en: {title: "My bills"} ,
                ru: {title: "Мои счета"} ,
            }, 
            content: {
                ru: {
                    zero_bills: 'У вас пока нет счетов',
                    copied: 'Скопировано',
                    error: 'Ошибка',
                    noAmount: 'Без суммы',
                    bill_title: "Счет от",
                    recipient_fullname: 'Имя получателя',
                    account_number: 'Номер счета',
                    phone_number: 'Номер телефона',
                    card_number: 'Номер счета',
                    description: 'Описание',
                    btn_detail: 'Подробно',
                    btn_to_pay: 'К оплате',
                    btn_create: 'Создать счет'
                },
                en: {
                    zero_bills: 'You don`t have bills yet',
                    copied: 'Copied',
                    error: 'Error',
                    noAmount: 'No amount',
                    bill_title: "Bill from",
                    recipient_fullname: "Recipient's name",
                    account_number: 'Account number',
                    phone_number: 'Phone number',
                    card_number: 'Card number',
                    description: 'Description',
                    btn_detail: 'Detail',
                    btn_to_pay: 'To pay',
                    btn_create: 'Create a bill'
                },
            },
            bank_list: []
        }
    },
    methods: {
        copy: function (text) {
            if(!text) return
            const url = this.connect.domain_url + '/bill/' + text
            this.helper.copy_clipboard(url)
            this.$toast.add({ severity: 'info', summary: this.content[this.lang_].copied, detail: url, life: 500 })
        },
        copyTg(hash){
            if(!hash) return
            const bot_username = 'pw_origin_bot'
            const url = `t.me/${bot_username}/app?startapp=bill-${hash}`
            this.helper.copy_clipboard(url)
            this.$toast.add({ severity: 'info', summary: this.content[this.lang_].copied, detail: url, life: 500 })
        },
        shareTg(hash, description=''){
            const bot_username = 'pw_origin_bot'
            const url = `t.me/${bot_username}/app?startapp=bill-${hash}`
            let text = `Счет на оплату через PayWave`
            if(description) text = text + '–' + description
            window.open(`https://t.me/share/url?url=${url}&text=${text}`, '_blank')
        },
        get_format_amount(value, currency, digits) {
            if(!value) return 0
            return this.helper.format_amount(value, currency, digits)
        },
        formatDate(value) {
            return this.helper.format_date_short(value)
        },
        detail_page(id){
            this.$router.push({ path: '/personal/bill/'+ id })
        },
        payPage(hash){
            const routeData = this.$router.resolve({path: '/bill/'+ hash})
            window.open(routeData.href, '_blank')
        },
        payPageTg(hash){
            this.$router.push({ path: '/bill/'+ hash })
        },
        async LoadBankList(){
            this.bank_list = await BankList.GetList(this.$store).then(r=>r)
            if(!this.bank_list || !this.bank_list.length) this.bank_list = []
        },
        getBankTitle(code){
            let bankObj = new BankList()
            bankObj.items = this.bank_list
            const bankCode = bankObj.GetTitle(code, this.lang_)
            return (bankCode) ? bankCode : code
        },
        getBankImage(code){
            let bankObj = new BankList()
            bankObj.items = this.bank_list
            const bankCode = bankObj.GetImage(code)
            return (bankCode) ? bankCode : null
        },
    },
    watch: { },
    computed: {
        isTgApp: function () { return this.$store.getters.StateTgApp },
        lang_() {
            return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
        }
    },
    mounted() {
        try {
            this.LoadBankList()
        } catch (error) {
            console.log('error', error)
        }
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>